export class ClientLookupCriteria {
  clientId: number = null;
  legalName: string = null;
  dateOfBirth: Date = null;
  emailAddress: string = null;
  phoneNumber: string = null;
}
